export const environment = {
    production: false,
    apiurl: 'https://fundcube-bk-qa.calmfield-d0780296.southafricanorth.azurecontainerapps.io',
    corsPolicy: 'QualCors',
    version: '847' 
};